module.exports = {
    valueFromEvt(e){
        return e.target.value;
    }
}


/** WEBPACK FOOTER **
 ** ./src/WebValueEventMixin.js
 **/